import { Flex } from "antd";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect, useState } from "react";
import { deleteRuleFile } from "services";
import { useStores } from "stores";
import { CustomButton, EditableFile } from "ui";
import { parseErrorMessage } from "utils";
import { AddRuleFileModal } from "./AddRuleFileModal";

export const RuleFiles = observer(({ id }: { id: string }) => {
  const { settings, actionModals, user } = useStores();
  const { openNotification } = useNotificationContext();

  const { roles } = user;

  const { isRiskManager, isSystemAdmin } = roles;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    settings.fetchRuleFiles();
  }, [settings]);

  const handleRemoveFile = async (fileId: string) => {
    if (loading) return;
    setLoading(true);
    return await deleteRuleFile({
      id: fileId,
    })
      .then(() => {
        setTimeout(() => {
          settings.fetchRuleFiles();
          setLoading(false);
        }, 1500);
      })
      .catch((e) => {
        setLoading(false);
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      });
  };

  const onAddRuleFile = () => {
    actionModals.open(() => <AddRuleFileModal />, {
      width: "600px",
      noValidation: true,
      title: "Загрузите файл",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };

  return (
    <Flex vertical gap="large">
      <Flex vertical gap="middle" id={id}>
        {settings.ruleFiles.length > 0 &&
          settings.ruleFiles.map((doc) => (
            <EditableFile
              file={{
                url: doc.url,
                docName: doc.docName,
                fileSize: doc.fileSize,
                uploadedAt: doc.uploadedAt,
              }}
              tooltip={"Правила платформы"}
              removeTooltip="Удалить документ"
              showRemoveIcon={isRiskManager || isSystemAdmin}
              key={doc.id}
              removeFileHandler={() => handleRemoveFile(doc.id)}
            />
          ))}
      </Flex>
      {(isRiskManager || isSystemAdmin) && (
        <CustomButton size="small" onClick={() => onAddRuleFile()} disabled={loading}>
          Добавить документ
        </CustomButton>
      )}
    </Flex>
  );
});
